import type { Country } from "../Country.js";
import type { CountrySettings } from "../CountrySettings.js";

/**
 * Standard VAT rate of the country as configured in the admin. It is the highest of the country’s VAT rates, since
 * every reduced, super-reduced or parking rate is lower by definition.
 */
export function getStandardTaxRate(country: Country, countrySettings: CountrySettings[]): number {
	const rates = countrySettings.find((setting) => setting.country === country)?.data?.vatRates.map(({ rate }) => rate);

	if (rates === undefined || rates.length === 0) {
		throw new Error(`Standard tax rate not found for country ${country}`);
	}

	return Math.max(...rates);
}
